export default [
  {
    path: '/digital-sign/:key?',
    name: 'DigitalSignIndex',
    component: () => import('@/views/digitalSign/DigitalSignIndex.vue'),
    meta: {},
  },
];